import InvestmentReducedOffer from './InvestmentReducedOffer'

export default InvestmentReducedOffer
